<template>
    <div class="mt20">
        <div class="one-title">健康状况</div>
        <avue-form ref="form" v-model="orderForm" :option="orderOption" @submit="handleSubmit" @error="error">
            <template slot="menuForm" v-if="!isDetail">
                <el-button type="primary" size="mini" @click="goNextHandle(1)">上一步</el-button>
                <el-button type="primary" size="mini" @click="goNextHandle(3)">下一步</el-button>
            </template>
        </avue-form>
        <div class="mt10 tac" v-if="isDetail">
            <el-button type="primary" size="mini" @click="goNextHandle(1)">上一步</el-button>
            <el-button type="primary" size="mini" @click="goNextHandle(3)">下一步</el-button>
        </div>
    </div>
</template>
<script>
import { add, update } from "@/api/archives/index";
export default {
    props: {
        data: {
            type: Object,
            default: {}
        },
        isDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            orderForm: {},
            orderOption: {
                size:'mini',
                detail: this.isDetail,
                emptyBtn: false,
                submitText: '保存',
                labelWidth: 78,
                group: [{
                    label: '问题需求',
                    prop: 'baseInfo',
                    column: [{
                            label: '需求跟进',
                            prop: 'needTo',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        },
                        {
                            labelWidth: 0,
                            prop: "needToRemark",
                            type: "textarea",
                            span: 24,
                        },
                        {
                            label: '危急因素',
                            prop: 'criticalFactors',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'critical_factors_ype'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        },
                        {
                            labelWidth: 0,
                            prop: "criticalFactorsRemark",
                            type: "textarea",
                            span: 24,
                        },
                        {
                            label: '紧急服务',
                            prop: 'emergencyService',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        },
                        {
                            labelWidth: 0,
                            prop: "emergencyServiceRemark",
                            type: "textarea",
                            span: 24,
                        }
                    ]
                }]
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler(val) {
                this.orderForm = this.data
            }
        }
    },
    mounted() {
        this.orderForm = this.data
    },
    methods: {
        goNextHandle(num) {
            this.$emit("next", num)
        },
        handleSubmit(form, done, loading) {
            update(this.orderForm).then((res) => {
                // 获取新增数据的相关字段
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                // 数据回调进行刷新
                this.$refs.form.resetForm();
                done();
                this.$emit("refresh", res.data.data.id || '')
            }, error => {
                done();
                window.console.log(error);
            });
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style lang="scss" scoped="scoped">
@import "@/styles/moudles/desk.scss";

</style>
<style lang="scss" scoped="scoped">
.one-title {
    padding: 30px 0;
    font-size: 20px;
    text-align: center;
}

</style>
